import { isBrowser as T } from "@smh/utils/is-in-browser";
import { guardExist as p, guardEmptyString as E } from "@smh/utils/guards";
const h = "__BSL_TEST_PASSIVE__", R = (t) => O() ? {
  passive: !1
} : t !== void 0 ? t : !1, O = () => {
  if (!T())
    return !1;
  let t = !1;
  const e = {
    get passive() {
      return t = !0, !1;
    }
  }, o = () => {
  };
  return window.addEventListener(h, o, e), window.removeEventListener(h, o, e), t;
}, v = (t) => {
  !t.cancelable || t.preventDefault();
}, I = (t, e, o) => {
  try {
    return new CustomEvent(t, {
      detail: e,
      ...o
    });
  } catch {
    const n = document.createEvent("CustomEvent");
    return n.initEvent(t, o == null ? void 0 : o.bubbles, o == null ? void 0 : o.cancelable), n;
  }
}, y = (t, e = document) => e.querySelector(t), P = (t, e = document) => e.querySelectorAll(t), Y = (t, e = document) => e.getElementsByClassName(t), $ = (t, e = document) => e.getElementsByTagName(t), D = (t) => document.getElementById(t), b = (t, e) => {
  const o = window.pageYOffset, n = "now" in window.performance ? performance.now() : new Date().getTime(), s = n + e, r = Math.max(
    document.body.scrollHeight,
    document.body.offsetHeight,
    document.documentElement.clientHeight,
    document.documentElement.scrollHeight,
    document.documentElement.offsetHeight
  ), c = window.innerHeight || document.documentElement.clientHeight || document.getElementsByTagName("body")[0].clientHeight, i = Math.round(
    r - t < c ? r - c : t
  );
  if (!("requestAnimationFrame" in window)) {
    window.scroll(0, i);
    return;
  }
  l();
  function l() {
    const d = "now" in window.performance ? performance.now() : new Date().getTime(), a = Math.min(1, (d - n) / e), f = Math.round(window.pageYOffset);
    window.scroll(0, Math.ceil(a * (i - o) + o)), !(f === i || d > s) && requestAnimationFrame(l);
  }
}, B = () => window.innerWidth - document.body.clientWidth, w = () => {
  var n;
  const { scrollingElement: t } = document;
  if (t)
    return t.scrollTop;
  const e = y("html"), o = y("body");
  return (n = e.scrollTop) != null ? n : o.scrollTop;
}, S = (t) => {
  const {
    top: e = 0,
    left: o,
    behavior: n = "auto",
    useFallback: s = !1,
    duration: r = 300
  } = t;
  s ? b(e, r) : window.scrollTo({
    top: e,
    left: o,
    behavior: n
  });
}, H = (t) => {
  const { event: e, clientX: o, clientY: n } = t, s = e.targetTouches[0].clientX - o, r = e.targetTouches[0].clientY - n;
  return {
    down: r > 0,
    up: r < 0,
    left: s < 0,
    right: s > 0,
    vertical: Math.abs(r) > Math.abs(s)
  };
}, _ = (t, e) => {
  const { scrollTop: o, scrollLeft: n, scrollWidth: s, scrollHeight: r, clientWidth: c, clientHeight: i } = t, { down: l, left: d, right: a, up: f } = e;
  return {
    isOnTop: l && o === 0,
    isOnLeft: a && n === 0,
    isOnRight: d && n + c + 1 >= s,
    isOnBottom: f && o + i + 1 >= r
  };
}, F = (t) => {
  const { event: e, target: o } = t;
  if (o !== void 0) {
    const n = H(t), { vertical: s } = n, { isOnBottom: r, isOnLeft: c, isOnRight: i, isOnTop: l } = _(
      o,
      n
    );
    if (s && (l || r) || !s && (c || i))
      return v(e);
  }
  return e.stopPropagation(), !0;
}, M = 300, m = (t, e) => {
  const o = {};
  return Object.keys(t).length === 0 ? o : e.reduce((n, s) => (n[s] = t[s], n), o);
}, W = (t, e, o) => {
  t.style[e] = o;
}, j = () => {
  const t = ["overflow", "boxSizing", "paddingRight"], e = y("body"), o = m(e.style, t), n = B();
  return e.style.overflow = "hidden", e.style.boxSizing = "border-box", e.style.paddingRight = `${n}px`, () => {
    t.forEach((s) => {
      var r;
      e.style[s] = (r = o[s]) != null ? r : "";
    });
  };
}, k = () => {
  const t = ["height"], e = ["top", "width", "height", "overflow", "position"], o = y("html"), n = y("body"), s = w(), r = m(o.style, t), c = m(n.style, e);
  return o.style.height = "auto", n.style.top = `-${s}px`, n.style.width = "100%", n.style.height = "auto", n.style.position = "fixed", n.style.overflow = "hidden", () => {
    var i, l;
    o.style.height = (i = r.height) != null ? i : "", o.style.overflow = (l = r.overflow) != null ? l : "", e.forEach((d) => {
      var a;
      n.style[d] = (a = c[d]) != null ? a : "";
    }), S({
      top: s,
      left: 0
    });
  };
}, X = () => {
  const t = ["position", "top", "left", "width", "overflow"], e = y("body"), o = m(e.style, t), { scrollY: n, scrollX: s } = window, r = w();
  return window.requestAnimationFrame(() => {
    const c = () => {
      setTimeout(
        () => window.requestAnimationFrame(() => {
          const i = innerHeight - window.innerHeight;
          if (i && n >= innerHeight) {
            const l = -(n + i);
            e.style.top = `${l}px`;
          }
        }),
        M
      );
    };
    e.style.position = "fixed", e.style.top = `-${n}px`, e.style.left = `-${s}px`, e.style.width = "100vw", e.style.overflow = "hidden", c();
  }), () => {
    t.forEach((c) => {
      var i;
      e.style[c] = (i = o[c]) != null ? i : "";
    }), S({
      top: r,
      left: 0
    });
  };
}, V = (t) => {
  const e = t.getBoundingClientRect().top;
  return document.documentElement.clientHeight - e;
}, u = (t) => p(t) && E(t), g = /* @__PURE__ */ new Set(), z = (t, e = !0) => new Promise((o, n) => {
  const s = document.createElement("script");
  if (s.type = "text/javascript", s.async = e, u(t.id) && (s.id = t.id), !u(t.src) && !u(t.content)) {
    n();
    return;
  }
  u(t.src) && !g.has(t.src) && (s.src = t.src, s.onload = () => {
    g.add(s.src), o(s);
  }, s.onerror = (c) => {
    n(c);
  }), u(t.content) && (s.innerHTML = t.content, u(t.src) || o(s)), (t.target || document.getElementsByTagName("head")[0]).appendChild(s);
}), U = (t, e, o, n) => `<link rel="preload" href="${t}" as="image" type="${e}" media="${o}"${p(n) ? ' imagesrcset="' + n + '"' : ""}>`, L = (t) => NodeList.prototype.isPrototypeOf.call(NodeList.prototype, t), C = (t) => Object.prototype.isPrototypeOf.call(HTMLCollection.prototype, t), x = (t) => Object.prototype.isPrototypeOf.call(HTMLElement.prototype, t), q = (t) => Object.prototype.isPrototypeOf.call(Element.prototype, t), G = (t, e) => {
  if (L(t) || C(t)) {
    if (Array.from(t).some((o) => o.contains(e)))
      return !0;
  } else if (x(t) || q(t)) {
    if (t.contains(e))
      return !0;
  } else
    throw new TypeError("Unexpected type of selector");
  return !1;
};
export {
  I as createCustomEvent,
  V as getElementMaxHeightByViewportBottom,
  _ as getElementScrollState,
  R as getPassiveEventListenerOptions,
  U as getPreloadImageString,
  B as getScrollBarWidth,
  w as getScrollTop,
  H as getTouchDirection,
  z as injectScript,
  G as isChildOfSelector,
  q as isElement,
  C as isHTMLCollection,
  x as isHTMLElement,
  L as isNodeList,
  O as isPassiveEventListenerSupported,
  m as pickStyle,
  F as preventBodyScroll,
  v as preventDefault,
  y as query,
  P as queryAll,
  Y as queryByClassName,
  D as queryById,
  $ as queryByTagName,
  S as scrollTo,
  X as setBodyOverflowHiddenIos,
  k as setBodyOverflowHiddenMobile,
  j as setBodyOverflowHiddenPc,
  W as setStyle
};
